<!--
  Маркировка версии интерфейса — полупрозрачная плашка поверх интерфейса,
  правый нижний угол.

  Зачем: версия UI попадает на ЛЮБОЙ скриншот, который присылают вместе с багом,
  а клик кладёт в буфер готовый диагностический блок (версия, тенант, роль,
  адрес страницы, браузер, время). Без неё «UI старый, corenode новый» по
  скриншоту не диагностируется вовсе.

  Монтируется один раз в `app/App.vue` — вне `router-view`, поэтому видна на всех
  страницах, включая вход (там тенант и роль в отчёт просто не попадают).
-->

<template>
  <div
    class="build-version-tag"
    role="button"
    tabindex="0"
    :title="title"
    @click="copyDiagnostics()"
    @keydown.enter.prevent="copyDiagnostics()"
    @keydown.space.prevent="copyDiagnostics()"
  >
    {{ version }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatBuildTitle, formatBuildVersion, readBuildInfo } from 'src/shared/lib/build-info'
import { useDiagnosticsReport } from 'src/shared/lib/use-diagnostics-report'

// Информация о сборке инлайнится в бандл на этапе сборки и за время жизни
// страницы не меняется — читаем один раз, без реактивности.
const info = readBuildInfo()
const version = computed(() => formatBuildVersion(info))
const title = computed(() => formatBuildTitle(info))

const { copyDiagnostics } = useDiagnosticsReport()
</script>

<style scoped lang="scss">
.build-version-tag {
  position: fixed;
  // Вплотную в угол окна: с отступом плашка ложилась на пагинацию q-table
  // («1-25 из 196 |< < > >|»), у самого края под ней только поля страницы.
  right: 0;
  bottom: 0;
  // Выше диалогов (6000) и drawer (3000), но НИЖЕ Notify (9500) и модального
  // NatsInspectorOverlay (9999): плашка не должна оказаться поверх того, что
  // человек в этот момент читает.
  z-index: 9000;
  padding: 2px 5px;
  // Скругление только у угла, смотрящего внутрь окна.
  border-radius: 3px 0 0 0;
  font-family: monospace;
  font-size: 9px;
  line-height: 1;
  // Светлый текст на тёмной подложке читается и в светлой, и в тёмной теме —
  // под плашкой может оказаться любой фон страницы.
  color: rgba(255, 255, 255, 0.95);
  background: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
}

.build-version-tag:hover,
.build-version-tag:focus-visible {
  background: rgba(0, 0, 0, 0.75);
  outline: none;
}
</style>
